module.exports = __webpack_public_path__ + "img/1-11.73fbb7b4.png";